"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Wrapper = exports.Wrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1taemdl0"
} : {
  target: "e1taemdl0",
  label: "Wrapper"
})(({
  maxWidth
}) => /*#__PURE__*/(0, _react.css)("padding:2em 2.5em;@media screen and (max-width: 768px){padding:1.5em 1em;}", maxWidth && /*#__PURE__*/(0, _react.css)("max-width:", maxWidth, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Wrapper;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Wrapper;")));